import { createRoot } from 'react-dom/client';
import ErrorBoundary from '@components/error-boundary/ErrorBoundary';
import { Provider } from 'react-redux';
import { store } from '@store';
import { RouterProvider } from 'react-router-dom';
import { router } from '@routing/createRouter';
import TagManager from 'react-gtm-module';
import '@styles/main.scss';



TagManager.initialize({ gtmId: 'GTM-MQ4N7MJJ' });



const Root = (): JSX.Element => {

	return (
		<ErrorBoundary>
			<Provider store={store}>
				<RouterProvider router={router} />
			</Provider>
		</ErrorBoundary>
	);
};

const root = createRoot(document.getElementById('root')!);
root.render(<Root />);